module.exports = __webpack_public_path__ + "img/bj.2c32c62e.svg";